import type { ReactNode } from "react"
import { RequireAuth } from "@lilbillbiscuit/account-ui"
import { useMe } from "@/lib/auth"

/**
 * Glue between the app's /api/me query and the shared RequireAuth component.
 * Pulls the loading/error/isAdmin shape from useMe so the gate can render the
 * right state without duplicating the fetch.
 */
export function AuthGate({ children, requireAdmin }: { children: ReactNode; requireAdmin?: boolean }) {
  const me = useMe()
  return (
    <RequireAuth
      isLoading={me.isLoading}
      error={me.error ?? null}
      isAdmin={me.data?.isAdmin ?? false}
      requireAdmin={requireAdmin}
    >
      {children}
    </RequireAuth>
  )
}
